
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"lime-fill",attrs:{"d":"M18.8 7.5h-4.3V5.6c0-.9.6-1.1 1-1.1h3v-4h-4.3c-3.9 0-4.7 2.9-4.7 4.8v2.1h-3v4h3v12h5v-12h3.9l.4-3.9z","fill":"#fff"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0z"}})])
          )
        }
      }
    